import classNames from "classnames";
import React, { useEffect, useRef } from "react";

interface Props {
  children: React.ReactNode;
  className?: string;
  minNumber: number;
  maxNumber?: number;
  disabled?: boolean;
  onChange: (value: string) => void;
}

export const Body14RegularInput: React.FC<Props> = ({
  children,
  minNumber,
  maxNumber,
  disabled,
  className,
  onChange,
}) => {
  const pRef = useRef<HTMLParagraphElement>(null);

  // children이 변경될 때마다 p 태그의 내용을 직접 업데이트
  useEffect(() => {
    if (pRef.current) {
      pRef.current.textContent = children?.toString() || "";
    }
  }, [children]);

  const handleBlur = (e: React.FocusEvent<HTMLParagraphElement>) => {
    const newValue = e.currentTarget.textContent?.trim() || "";

    if (
      disabled ||
      isNaN(Number(newValue)) ||
      Number(newValue) < minNumber ||
      (maxNumber && Number(newValue) > maxNumber)
    ) {
      if (pRef.current) {
        pRef.current.textContent = minNumber.toString();
      }
      onChange(minNumber.toString());
      return;
    }

    onChange(newValue);
  };

  const classNamesString = classNames(
    "text-body-14 font-regular leading-body-14 whitespace-nowrap",
    className
  );

  return (
    <p
      ref={pRef}
      className={classNamesString}
      contentEditable={!disabled}
      suppressContentEditableWarning
      onBlur={handleBlur}
    >
      {children?.toString()}
    </p>
  );
};